<template lang="pug">
  v-dialog.grey(v-model="dialog" scrollable max-width="1100")
    template(v-slot:activator="{ on }")
      v-btn(v-on="on" color="primary") {{ buttonText }}
    v-card
      v-card-title.d-flex.flex-nowrap.justify-space-between.headline.text-center(primary-title)
        span {{ title }} {{ name }}
        v-btn(@click="dialog = false" icon)
          v-icon mdi-close
      v-card-text.fantasy__scrollbar.px-2.px-sm-6
        v-container(fluid)
          v-row
            v-col(cols="12")
              v-simple-table
                template(default)
                  thead
                    tr
                      th {{ table.competition }}
                      th {{ table.team }}
                      th {{ table.points }}
                      th {{ table.value }}
                  tbody
                    tr(v-for="(item,i) in competitions"  :key="i")
                      td {{ findCompetition(item.c).name }}
                      td {{ item.t.n }}
                      td {{ item.p }}
                      td {{ item.v }}
</template>

<script>
  export default {
    name: "PlayerCompetitionInfoDialog",
    props: {
      buttonText: {
        type: String,
        default: 'See competition'
      },
      title: {
        type: String,
        default: 'Points and values'
      },
      table: {
        type: Object,
        default: function(){
          return {
            competition: 'Competition',
            points: 'Points',
            value: 'Value',
          }
        }
      },
      name: {
        type: String,
        default: ''
      },
      competitions:{
        type: Array,
        default:function(){
          [{
            _id:'',
            id:'',
            value: 0,
            points: 0,
            team: ''
          }]
        }
      }
    },
    data:() => ({
      dialog: false,
    }),
    methods:{
      findCompetition(idCompetition){
        return this.$store.state.fantasy.competitions.find(item =>{ return item._id == idCompetition });
      },
    }
  }
</script>

<style lang="sass">
</style>